import { useState } from 'react';

import { AccountLockedCard } from '@/entities/account';
import { ContinueWithGoogle } from '@/features/users/continue-with-google';
import {
    SignInWithPassword,
    SignInWithPasswordCooldownAlert,
} from '@/features/users/sign-in-with-password';
import { AuthCard } from '@/shared/ui/auth/auth-card';
import { AuthOrDivider } from '@/shared/ui/auth/auth-or-divider';
import { ThreatProtectionScript } from '@/shared/ui/auth/threat-protection-script';

type Props = {
    role: string;
    returnUrl?: string;
};

export function SignInForm({ role, returnUrl }: Props) {
    const [retryAfterSeconds, setRetryAfterSeconds] = useState<number | null>(null);
    const [locked, setLocked] = useState<{ email: string } | null>(null);

    const isCoolingDown = retryAfterSeconds !== null;

    if (locked) {
        return <AccountLockedCard email={locked.email} />;
    }

    return (
        <div className="flex flex-1 items-start justify-center px-4">
            <ThreatProtectionScript />
            <AuthCard className="mt-28">
                <h1 className="text-3xl font-bold md:text-4xl">Welcome back</h1>
                {retryAfterSeconds !== null && (
                    <SignInWithPasswordCooldownAlert retryAfterSeconds={retryAfterSeconds} />
                )}
                <ContinueWithGoogle
                    role={role}
                    returnUrl={returnUrl}
                    label="Log in with Google"
                    disabled={isCoolingDown}
                />
                <AuthOrDivider />
                <SignInWithPassword
                    role={role}
                    returnUrl={returnUrl}
                    onCooldownChange={setRetryAfterSeconds}
                    onLocked={setLocked}
                />
            </AuthCard>
        </div>
    );
}
